export const apiEndpoint = process.env.REACT_APP_API_ENDPOINTS + `/api/admin/v1`;
export const isAxioMock = process.env.REACT_APP_IS_AXIOS_MOCK;
export const clientEndpoint = process.env.REACT_APP_CLIENT_ENDPOINT;

export const googleRecaptchaKey =
  process.env.REACT_APP_GOOGLE_RECAPTCHA_KEY ?? "6LfJn3AeAAAAALbYq8VKRb64xHPioNiDCIsAlyAP";

export const cryptoImagePrefix =
  process.env.REACT_APP_COINGECK_CRYPTO_IMAGE ??
  "https://s2.coinmarketcap.com/static/img/coins/64x64";
